import Modal from "../Modal";
import { CancelBtn, MediumContainer, NextBtn } from "../../screens/User/Users/components/IncidentType/incident.style";
import { AiOutlineClose } from "react-icons/ai";
import { useEffect, useState } from "react";

interface Props {
  open: boolean;
  onClose: () => void;
  onMarkReady: () => void;
  onApprove?: () => void;
  confirmLoading?: boolean;
  canUserSignOff?: boolean;
}

const MarkReadyConfirmModal: React.FC<Props> = ({
  open,
  onClose,
  onMarkReady,
  onApprove,
  confirmLoading = false,
  canUserSignOff = false,
}) => {
  const [pendingAction, setPendingAction] = useState<"approve" | "markReady" | null>(null);

  useEffect(() => {
    if (!confirmLoading) {
      setPendingAction(null);
    }
  }, [confirmLoading]);

  // Variant 1: User can sign off on the incident
  if (canUserSignOff) {
    return (
      <Modal open={open} close={onClose}>
        <MediumContainer>
          <div className="flex justify-end">
            <button
              className="cursor-pointer border-0 bg-transparent"
              onClick={onClose}
              style={{ fontSize: "24px" }}
            >
              <AiOutlineClose size={20} />
            </button>
          </div>
          <p className="text-md px-5 py-5 text-center font-semibold">
            Would you like to sign and close the incident?
          </p>
          <div className="mb-14 mr-7 mt-5 flex justify-center gap-4">
            <NextBtn
              onClick={() => {
                setPendingAction("approve");
                onApprove?.();
              }}
              disabled={confirmLoading}
            >
              {confirmLoading && pendingAction === "approve" ? "Approving..." : "Approve"}
            </NextBtn>
            <CancelBtn
              onClick={() => {
                setPendingAction("markReady");
                onMarkReady();
              }}
              disabled={confirmLoading}
            >
              {confirmLoading && pendingAction === "markReady"
                ? "Marking..."
                : "Mark Ready For Approval"}
            </CancelBtn>
          </div>
        </MediumContainer>
      </Modal>
    );
  }

  // Variant 2: User cannot sign off, only mark ready
  return (
    <Modal open={open} close={onClose}>
      <MediumContainer>
        <div className="flex justify-end">
          <button
            className="cursor-pointer border-0 bg-transparent"
            onClick={onClose}
            style={{ fontSize: "24px" }}
          >
            <AiOutlineClose size={20} />
          </button>
        </div>
        <p className="text-md px-5 py-5 text-center font-semibold">
          Would you like to mark this incident as Ready for Approval?
        </p>
        <div className="mb-14 mr-7 mt-5 flex justify-center gap-4">
          <NextBtn
            onClick={() => {
              setPendingAction("markReady");
              onMarkReady();
            }}
            disabled={confirmLoading}
          >
            {confirmLoading && pendingAction === "markReady"
              ? "Marking..."
              : "Yes, Mark Ready"}
          </NextBtn>
          <CancelBtn onClick={onClose} disabled={confirmLoading}>
            Cancel
          </CancelBtn>
        </div>
      </MediumContainer>
    </Modal>
  );
};

export default MarkReadyConfirmModal;
